function wishlistChangeHandler() {
  const wishlistButtons = document.querySelectorAll('.js-wishlist-engine');

  wishlistButtons.forEach((wishlistButton) => {
    if (!wishlistButton) return;

    wishlistButton.addEventListener('click', function() {
      const variantSku = wishlistButton?.dataset?.variant_sku;
      const productName = wishlistButton?.dataset?.product_name;
      const productPrice = wishlistButton?.dataset?.product_price;
      const addedStatusBefore = wishlistButton?.dataset?.added;

      setTimeout(() => {
        const addedStatusAfter = wishlistButton?.dataset?.added;
        if ((addedStatusBefore === 'false' || addedStatusBefore === false) && (addedStatusAfter === 'true' || addedStatusAfter === true)) {
          Shopify?.analytics?.publish?.('fbq_add_to_wish_list', {
            content_ids: [variantSku],
            content_name: productName,
            value: productPrice
          });
        }
      }, 2000);
    });
  })
}

window.addEventListener('DOMContentLoaded', () => {
  wishlistChangeHandler();
});